import React, {useState} from 'react';
import {Image, useColorMode} from '@chakra-ui/react';
import Select from "../Select.tsx";
import {languagesItems, ILanguage} from '../../mocks/languagesItems.tsx';
import {twMerge} from "tailwind-merge";

const Appearance: React.FC = () => {
  const {colorMode, setColorMode} = useColorMode();
  const [language, setLanguage] = useState<ILanguage>(languagesItems[0]);

  const items = [
    {
      title: "Light mode",
      image: "src/mocks/images/theme-light.svg",
      active: colorMode === "light",
      onClick: () => setColorMode("light"),
    },
    {
      title: "Dark mode",
      image: "src/mocks/images/theme-dark.svg",
      active: colorMode === "dark",
      onClick: () => setColorMode("dark"),
    },
  ];

  return (
    <>
      <div className="mb-8 h4">Appearance</div>
      <div className="mb-5 base1 font-semibold">Appearance</div>
      <div className="flex mb-8 space-x-8">
        {items.map((item, index) => (
          <button
            className={twMerge(
              `basis-1/2 p-3 border-4 border-transparent bg-n-200 rounded-2xl text-left transition-colors dark:bg-n-600 dark:text-n-300/50 ${
                item.active &&
                "bg-transparent border-brandPurple-500 text-n-600/50 dark:text-n-100 dark:bg-transparent"
              }`
            )}
            key={index}
            onClick={item.onClick}
          >
            <div className="mb-3">
              <Image
                className="w-full max-w-[128px] h-[80px] object-contain rounded-xl mx-auto"
                src={item.image}
                alt=""
              />
            </div>
            {item.title}
          </button>
        ))}
      </div>
      <div className="flex items-center md:block">
        <div className="mr-auto base1 font-semibold md:mb-4">
          Primary language
        </div>
        <Select
          className="min-w-[13.125rem]"
          classButton="bg-n-300/75 dark:bg-n-600 dark:shadow-[inset_0_0_0_0.0625rem_#232627]"
          items={languagesItems}
          value={language}
          onChange={setLanguage}
          up
        />
      </div>
    </>
  );
};

export default Appearance;